import React, { useState } from 'react';

const Production = ({ currentUser }) => {
  const [activeTab, setActiveTab] = useState('ims-update');
  const { permissions } = currentUser;

  return (
    <div className="bg-card-background rounded-xl p-8 border border-border-color">
      <h2 className="text-2xl font-bold text-foreground mb-6">Production</h2>
      <div className="flex border-b">
        {permissions.canViewIMSUpdate && (
          <button
            className={`py-2 px-4 ${activeTab === 'ims-update' ? 'border-b-2 border-blue-500' : ''}`}
            onClick={() => setActiveTab('ims-update')}
          >
            IMS Update
          </button>
        )}
      </div>
      <div className="p-4">
        {activeTab === 'ims-update' && permissions.canViewIMSUpdate && (
          <div>IMS Update Content</div>
        )}
      </div>
    </div>
  );
};

export default Production;
